import { Link } from 'react-router-dom'
import { getItemLink, getItemId, getItemName, getItemIcon } from './utils'
import HighlightText from './HighlightText'
import noFavorite from '../../assets/images/noFavorite.png'
import favorite from '../../assets/images/yesFavorite.png'
import { CoverCard } from '@shared/ui/CoverCard'

interface InteractiveSimpleCategoryCardProps {
  item: any
  showingType: 'subcategories' | 'cards'
  onCategoryClick?: (categoryId: number) => void
  onToggleFavorite?: (itemId: string) => void
  isFavorite?: boolean
  hasSubscription?: boolean
  searchQuery?: string
  onScrollToTop?: () => void
  lockContent?: boolean
}

const InteractiveSimpleCategoryCard = ({
  item,
  showingType,
  onCategoryClick,
  onToggleFavorite,
  isFavorite,
  hasSubscription,
  searchQuery = '',
  onScrollToTop,
  lockContent = false,
}: InteractiveSimpleCategoryCardProps) => {
  const handleClick = (e: React.MouseEvent) => {
    if (showingType === 'subcategories' && onCategoryClick) {
      e.preventDefault()
      onScrollToTop?.()
      onCategoryClick(item.category_id)
    }
    // Для карточек (showingType === 'cards') позволяем стандартную навигацию по ссылке
  }

  const handleFavoriteClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    if (onToggleFavorite) {
      onToggleFavorite(getItemId(item, showingType).toString())
    }
  }

  const showFavoriteButton =
    hasSubscription && showingType === 'cards' && onToggleFavorite

  return (
    <Link
      key={getItemId(item, showingType)}
      to={getItemLink(item, showingType)}
      className="category-card"
      onClick={handleClick}
    >
      <CoverCard
        isFluid
        isStatic
        image={getItemIcon(item)}
        title={
          <HighlightText
            text={getItemName(item, showingType)}
            searchQuery={searchQuery}
          />
        }
        isLocked={lockContent}
        action={
          showFavoriteButton ? (
            <button
              className={`favorite-button ${isFavorite ? 'favorite-active' : ''}`}
              onClick={handleFavoriteClick}
              title={
                isFavorite ? 'Удалить из избранного' : 'Добавить в избранное'
              }
            >
              <img
                src={isFavorite ? favorite : noFavorite}
                alt={isFavorite ? 'favorite' : 'noFavorite'}
                className="favorite-icon"
              />
            </button>
          ) : undefined
        }
      />
    </Link>
  )
}

export default InteractiveSimpleCategoryCard
